<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <b-overlay :show="loading" rounded="sm">
        <form autocomplete="off" @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row container-fluid">

              <div class="form-group col-md-12">
                <label for="name"><b>Rol&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.name" type="text" class="form-control" id="name" name="name" placeholder="Nombre del rol">
                <span v-if="nameValid" class="text-danger" style="font-size: 10px;"><b>El campo Rol es requerido.</b></span>
              </div>

              <div class="form-group col-md-12">
                <label><b>Permisos&nbsp;<span class="asterisk">*</span></b></label>
                <div class="row">
                  <div class="col-md-6" v-for="permission in permissions" :key="permission.slug">
                    <div class="custom-control custom-checkbox mb-1">
                      <input type="checkbox" class="custom-control-input" :id="'perm_' + permission.slug" :value="permission.slug" v-model="form.permissions">
                      <label class="custom-control-label" :for="'perm_' + permission.slug">
                        <b>{{ permission.label }}</b><br>
                        <small class="text-muted">{{ permission.description }}</small>
                      </label>
                    </div>
                  </div>
                </div>
                <span v-if="permissionsValid" class="text-danger" style="font-size: 10px;"><b>Debe seleccionar al menos un permiso.</b></span>
              </div>

              <div class="form-group col-md-12">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="is_module_admin" v-model="form.is_module_admin">
                  <label class="custom-control-label" for="is_module_admin"><b>Administrador de Módulo</b></label>
                </div>
              </div>

              <input v-model="form.id" type="hidden" class="form-control" id="id" name="id">

            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
          </div>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BOverlay } from 'bootstrap-vue';

export default {
  components: {BModal, BOverlay},
  props: ['id', 'showModal'],
  data() {
    return {
      form: {
        id: null,
        name: '',
        permissions: [],
        is_module_admin: false,
      },
      permissions: [],
      nameValid: false,
      permissionsValid: false,
      loading: false,
      textMessage: 'Crear Rol',
    }
  },
  created() {
    this.getPermissions();
  },
  methods:{
    getPermissions() {
      axios.get('/configuration/roles/getPermissions')
        .then(response => {
          this.permissions = response.data.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    close() {
      this.resetForm();
      this.$emit('update:showModal', false);
      this.$emit('getRecords');
    },
    cancel() {
      this.resetForm();
      this.$emit('update:showModal', false);
    },
    resetForm() {
      // permissions debe ser un array: si queda undefined, v-model sobre los
      // checkboxes deja de funcionar.
      this.form = {
        id: null,
        name: '',
        permissions: [],
        is_module_admin: false,
      };
      this.nameValid = false;
      this.permissionsValid = false;
      this.textMessage = 'Crear Rol';
    },
    getRecord() {
      this.loading = true;

      if (this.id) {
        axios.get(`/configuration/roles/${this.id}`)
          .then(response => {
            this.textMessage = 'Editar Rol';
            this.form = {
              id: response.data.id,
              name: response.data.name,
              permissions: response.data.permissions || [],
              is_module_admin: response.data.is_module_admin === true,
            };
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.resetForm();
        this.loading = false;
      }
    },
    submitForm() {
      this.nameValid = false;
      this.permissionsValid = false;

      if (this.form.name == '' || this.form.name == null) {
        this.nameValid = true;
      }

      if (!this.form.permissions || this.form.permissions.length === 0) {
        this.permissionsValid = true;
      }

      if (this.nameValid == true || this.permissionsValid == true) {
        return;
      }

      this.loading = true;

      axios.post('/configuration/roles', {
        id: this.id ? this.form.id : null,
        name: this.form.name,
        permissions: this.form.permissions,
        is_module_admin: this.form.is_module_admin,
      })
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            this.close();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error('No se pudo guardar el registro', 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>
